const TOKEN_KEY = 'needl.auth.token';
const USER_KEY = 'needl.auth.user';

function emitAuthChanged() {
  try {
    // 'storage' does not fire in the same tab, so we emit our own event too.
    window.dispatchEvent(new Event('needl:auth-changed'));
  } catch {
    // ignore
  }
}

export function getAuthToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function setAuthSession({ token, user }) {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    if (user) window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch {
    // ignore storage errors
  }
  emitAuthChanged();
}

export function clearAuthSession() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
  } catch {
    // ignore
  }
  emitAuthChanged();
}

export function getAuthUser() {
  try {
    const raw = window.localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getAuthHeader() {
  const token = getAuthToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}




